const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/v1"
).replace(/\/$/, "");

export const buildApiUrl = (path) => `${API_BASE_URL}${path}`;

export default API_BASE_URL;
